export const EXPERT_PHOTO_FACE_VERTICAL_CENER = 1100;
export const LARGE_MONITOR_CORRECTION = 285;
